import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

let resizeTimeout;
let swiper;
let nextEl;
let prevEl;
let paginationEl;
let cont;

function createSwiper() {
    return new Swiper(cont, { // eslint-disable-line no-new
        // grabCursor: true,
        loop: true,
        modules: [Navigation, Pagination],
        navigation: {
            nextEl,
            prevEl,
        },
        pagination: {
            el: paginationEl,
        },
        // slidesPerView: 1,
    });
}

export default function ImageCarousel(el) {
    cont = el.querySelector('div');

    if (!cont) return;

    // swiper gallery will ignore responsive sizes (i.e. width: 100%) so setting a fixed width
    el.style.width = window.getComputedStyle(el.parentElement).width;

    // mostly for dev testing, update swiper width on window resize
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(() => {
            el.style.display = 'none';
            swiper.destroy();
            el.style.width = window.getComputedStyle(el.parentElement).width;
            el.style.display = 'block';
            swiper = createSwiper();
        }, 250);
    });

    [prevEl, nextEl] = el.querySelectorAll('[data-nav-button]');
    paginationEl = el.querySelector('[data-nav-dots]');

    swiper = createSwiper();
}
